const Config = {
  baseURL: 'https://www.aborashad.com/api',
  mediaURL: 'https://www.aborashad.com'
};

export default Config;